import { Container, Stack, Typography } from '@mui/material';
import * as Sentry from '@sentry/gatsby';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton/index';

import { LOGIN } from '@constants/routes';

const messages = defineMessages({
  title: {
    id: 'sentryErrBoundary.title',
    defaultMessage: 'Something went wrong.',
  },
  report: {
    id: 'sentryErrBoundary.report',
    defaultMessage: 'Report Feedback',
  },
  login: {
    id: 'sentryErrBoundary.login',
    defaultMessage: 'Back to Login',
  },
  or: {
    id: 'GLOBAl.or',
    defaultMessage: 'Or',
  },
});

const SentryErrorBoundaryFallback: Sentry.FallbackRender = ({
  resetError,
  eventId,
}: {
  resetError: () => void;
  eventId: string;
}) => {
  const { formatMessage } = useIntl();
  const handleShowDialog = () => {
    Sentry.showReportDialog({ eventId });
  };

  const handleReset = () => {
    resetError();
    navigate(LOGIN);
  };

  return (
    <Container maxWidth="md">
      {/* TODO: Add the VITALL logo or error img */}
      <Stack direction="column" justifyContent="center" alignItems="center">
        <Typography>{formatMessage(messages.title)}</Typography>

        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <RoundedButton onClick={handleShowDialog}>
            {formatMessage(messages.report)}
          </RoundedButton>
          <Typography>{formatMessage(messages.or)}</Typography>
          <RoundedButton onClick={handleReset}>
            {formatMessage(messages.login)}
          </RoundedButton>
        </Stack>
      </Stack>
    </Container>
  );
};

export default SentryErrorBoundaryFallback;
